<template>
  <div class="vr360-flex-column vr360-app-main__one-stream">

    <div class="vr360-app__stream">
      <div class="vr360-app__stream__header" v-if="stream.owner && stream.owner.id !== user.id">
        <p class="vr360-app__stream__header__avatar">
          <template  v-if="stream.owner.avatar">
            <img class="vr360-avatar-stub" :src="stream.owner.avatar | storagePath" alt="">
          </template>
          <template v-else>
            <img class="vr360-avatar-stub" :src="'#'" alt="">
          </template>
          <span class="vr360-text-reg vr360-text-elips">{{stream.owner.name}} {{stream.owner.surname}}</span>
        </p>
        <p class="vr360-live" v-if="stream.live">
          <span class="vr360-text-caption">Live</span>
        </p>
      </div>

      <div class="vr360-app__stream__main">
        <div class="vr360-stream-stub vr360-app__stream__main__poster">
          <template  v-if="stream.poster">
            <img :src="stream.poster | storagePath" alt="">
          </template>
          <!-- <span class="vr360-text-caption vr360-text-white">{{stream.duration | secondsTohhmmss }}</span> -->
        </div>
        <p class="vr360-head-h4">{{stream.title}}</p>
      </div>

      <div class="vr360-app__stream__footer">
        <p class="vr360-app__stream__footer__likes">
          <!-- <button type="button" class="vr360-checkbox-like" :class="{ 'is-liked' : stream.isLikedMe }" @click="toggleLike">
            <i class="vr360-icon bg-like"></i>
            <span></span>
          </button> -->
          <span type="button" class="vr360-checkbox-like" :class="{ 'is-liked' : stream.isLikedMe }">
            <i class="vr360-icon bg-like"></i>
            <span></span>
          </span>
          <span class="vr360-text-caption">{{stream.likes_count}}</span>
        </p>
        <p class="vr360-app__stream__footer__views">
          <i class="vr360-icon bg-eye"></i>
          <span class="vr360-text-caption">{{stream.watched}}</span>
        </p>
      </div>

      <div class="vr360-app__stream__desc">
        <p class="vr360-text-reg">{{stream.description}}</p>
      </div>
    </div>

    <div class="vr360-app-main__bottom">
      <router-link :to="{ name: 'ShowStream', params: { id } }" class="vr360-btn">
        <span>Watch in VR</span>
      </router-link>
      <template  v-if="stream.owner_id && stream.owner_id === user.id">
        <button type="button" @click="share" class="vr360-btn vr360-btn--cut">
          <span>Share stream</span>
        </button>
      </template>
    </div>

    <modal :params="{ closeBtn: false }">
      <template>
        <div class="vr360-modal__cont__header">
          <i class="vr360-icon bg-delete-project"></i>
        </div>
        <div class="vr360-modal__cont__main">
          <p class="vr360-head-h4">Do you want delete stream “{{stream.title}}”</p>
          <p class="vr360-text-reg">Keep in mind that it will be deleted from cloud storage</p>
        </div>
        <div class="vr360-modal__cont__footer">
          <button type="button" @click="remove" class="vr360-btn">
            <span>Yes</span>
          </button>
          <button type="button" @click="hideModal" class="vr360-btn vr360-btn--cut">
            <span>No</span>
          </button>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import Modal from "@/components/partials/Modal";

let time = 0;

export default {
  name: "ItemStream",
  components: {
    Modal
  },
  data() {
    return {
      id: null,
      enableCount: true
    };
  },
  created() {
    if (!this.stream.id) {
      this.id = this.$route.params.id;
      this.getStream(this.$route.params.id);
    } else {
      this.id = this.stream.id;
    }

    // requestAnimationFrame(this.timer);
  },

  destroyed() {
    this.enableCount = false;
    
  },
  methods: {
    ...mapActions({
      toggleLikeStream: "stream/toggleLikeStream",
      hideModal: "hideModal",
      showNotification: "showNotification",
      getStream: "stream/fetchStream",
      removeStream: "stream/removeStream"
    }),
    toggleLike() {
      this.toggleLikeStream(this.stream.id);
    },
    remove() {
      this.hideModal();
      this.$router.go(-1);
      this.removeStream(this.id);
    },
    timer(stamp) {
      const currentSec = Math.floor(stamp / 1000) * 1000;
      if (currentSec > time) {
        time = currentSec;

        this.stream.currentTime += 1;
      }
      if (this.enableCount) {
        requestAnimationFrame(this.timer);
      }
    },
    share() {
      const path =
        window.location.origin + "/shared-stream/" + this.stream.token_shared;
      if ("share" in navigator) {
        navigator.share({
          title: "Mecha VR360HF",
          text: "Stream to share with the URL",
          url: path
        });
      } else {
        this.$copyText(path).then(
          () => {
            this.showNotification({
              type: "success",
              message: "Copied!"
            });
          },
          () => {
            this.showNotification({
              type: "error",
              message: "Can`t copy url"
            });
          }
        );
      }
    }
  },
  computed: {
    ...mapGetters({
      stream: "stream/currentStream",
      user: "user/user"
    })
  }
};
</script>

<style lang="scss">
.poster-container {
  position: relative;
  display: inline-flex;

  span {
    position: absolute;
    bottom: 0;
    right: 0;
    padding: 0.1em 0.2em;
    background-color: red;
  }
}
</style>
